export default {
  "title": "全球最权威的专家",
  "anchor": "tutor",
  "items": [
    "王小川",
    "傅盛",
    "周航",
    "李志飞",
    "张鹏",
    "黎万强",
    "周鸿祎",
    "刘宗孺",
    "余凯",
    "陈大年",
    "黄汪",
    "沈晖",
    "周源",
    "胡玮炜",
    "张志东",
    "曾德钧",
    "李宇",
    "罗小渠",
    "何帆",
    "陈磊华",
    "薄满辉",
    "王佳梁",
    "王智民",
    "翟学魂",
    "宋晨枫",
    "杨洋",
    "吴甘沙",
    "何小鹏",
    "齐俊元",
    "宋少鹏",
    "顾嘉唯",
    "赖奕龙",
    "米雯娟",
    "朱继志",
    "沈鹏",
    "李斌",
    "张宏江",
    "李泽湘",
    "董熠",
    "李学凌",
    "张智武",
    "戴雷",
    "张凯磊"
  ]
}



// WEBPACK FOOTER //
// ./src/mock/tutor.js